import { render, staticRenderFns } from "./MyOrderClient.vue?vue&type=template&id=623f5818&scoped=true&"
import script from "./MyOrderClient.vue?vue&type=script&lang=js&"
export * from "./MyOrderClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f5818",
  null
  
)

export default component.exports